:host {
  display: block;
  width: 100%;
  height: 100%;
}

:host([hideswatch]) uui-theme-swatch {
  display: none;
}

:host([hidethemeselector]) uui-theme-selector {
  display: none;
}

.controls {
  display: flex;
  column-gap: var(--uui-medium-gap);
  padding: var(--uui-medium-gap);
  align-items: center;
  align-content: flex-start;
  background-color: var(--uui-theme-on-core-900);
}
